













import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import OutstandingApi from "@/consoleapi/api/outstanding";

@Component
export default class ImportantNoticesIndex extends Vue {
    @Prop() bearerToken!: string;
    @Prop() accountId!: string;
    @Prop() userId!: string;
    @Prop() outstandingInvoiceId!: string;

    mounted(): void {
        this.getNotification();
    }

    private getNotification(){
        const outstandingApi = new OutstandingApi();
        outstandingApi.setBearerToken(this.bearerToken);
        outstandingApi.get(this.accountId).then(response => {
            const outstandingInvoice = response.data.outstanding_invoice;
            this.inputOutstandingInvoiceIdEmit(outstandingInvoice.id);
        }).catch(error => {
            if(error.response.status === 404){
                // 処理なし
            }
            // console.log(error.response);
        });
    }

    private showOutstandingInvoice(){
        this.$router.push('/outstanding')
    }

    @Emit()
    public inputOutstandingInvoiceIdEmit(inputOutstandingInvoiceId: string) {
        // console.log('Emit1=>' + inputOutstandingInvoiceId);
    }

    private get inputOutstandingInvoiceId(): string {
        return this.outstandingInvoiceId;
    }

    private set inputOutstandingInvoiceId(outstandingInvoiceId: string) {
        this.inputOutstandingInvoiceIdEmit(outstandingInvoiceId);
    }
}
